import {
    GRUPOTECNICO_LIST,
    GRUPOTECNICO_FULLLIST,
    GRUPOTECNICO_LISTA,
    GRUPOTECNICO_FILTER,
    GRUPOTECNICO_CREATE,
    GRUPOTECNICO_CREATE_SUCCESS,
    GRUPOTECNICO_LIST_SUCCESS,
    GRUPOTECNICO_FULLLIST_SUCCESS,
    GRUPOTECNICO_REQUEST_FAILED,
    GRUPOTECNICO_UPDATE,
    GRUPOTECNICO_UPDATE_SUCCESS,
    GRUPOTECNICO_READ,
    GRUPOTECNICO_READ_SUCCESS,
    GRUPOTECNICO_DELETE,
    GRUPOTECNICO_DELETE_SUCCESS
  } from "./actionTypes";
  
  const initialState = {
    grupotecnico: [],
    grupotecnicoCreated: {},
    grupotecnicoUpdated: {},
    grupotecnicoDeleted:false,
    loading: false,
    error: "",
  };
  
  const grupotecnico = (state = initialState, action) => {
    switch (action.type) {
      case GRUPOTECNICO_CREATE:
        state = {
          ...state,
          loading: true,
        };
        break;
      case GRUPOTECNICO_LIST:
        state = {
          ...state,
          loading: true,
        };
        break;
      case GRUPOTECNICO_FULLLIST:
        state = {
          ...state,
          loading: true,
        };
        break;
      case GRUPOTECNICO_LISTA:
        state = {
          ...state,
          loading: true,
        };
        break;
      case GRUPOTECNICO_FILTER:
        state = {
          ...state,
          loading: true,
        };
        break;
        case GRUPOTECNICO_READ:
          state = {
            ...state,
            loading: true,
          };
          break;
          case GRUPOTECNICO_CREATE_SUCCESS:
        state = {
          ...state,
          loading: false,
          grupotecnicoCreated: action.payload,
          error: "",
        };
        break;
      case GRUPOTECNICO_UPDATE:
        state = {
          ...state,
          loading: true,
        };
        break;
        case GRUPOTECNICO_DELETE:
        state = {
          ...state,
          loading: true,
          grupotecnicoDeleted: false,
        };
        break;
        case GRUPOTECNICO_DELETE_SUCCESS:
          state = {
            ...state,
            loading: false,
            grupotecnicoDeleted: true,
            error: "",
          };
          break;
      case GRUPOTECNICO_READ_SUCCESS:
        state = {
          ...state,
          loading: false,
          grupotecnico: action.payload,
          error: "",
        };
        break;
      case GRUPOTECNICO_LIST_SUCCESS:
        state = {
          ...state,
          loading: false,
          grupotecnico: action.payload,
          grupotecnicoCreated: {},
          grupotecnicoUpdated: {},
          grupotecnicoDeleted: false,
          error: "",
        };
        break;
      case GRUPOTECNICO_FULLLIST_SUCCESS:
        state = {
          ...state,
          loading: false,
          grupotecnico: action.payload,
          grupotecnicoCreated: {},
          grupotecnicoUpdated: {},
          grupotecnicoDeleted: false,
          error: "",
        };
        break;
      case GRUPOTECNICO_UPDATE_SUCCESS:
        state = {
          ...state,
          loading: false,
          grupotecnicoUpdated: action.payload,
          error: "",
        };
        break;
      case GRUPOTECNICO_REQUEST_FAILED:
        state = {
          ...state,
          loading: false,
          error: action.payload,
        };
        break;
      default:
        state = { ...state };
        break;
    }
    return state;
  };
  
  export default grupotecnico;
  